import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import styles from './blog.module.css'
import pageStyles from './page.module.css'
import EventPreview from '../components/event-preview'
import moment from 'moment'

class EventIndex extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const posts = get(this, 'props.data.allContentfulEvent.edges')

    const siteData = get(this.props, 'data.site.siteMetadata')
    const siteDescription = 'Yuk ikutin event-event asik yang diadakan oleh YOUCAT Indonesia ini'

    const moment = require(`moment`);

    return (
      <div style={{ background: '#fff' }}  className="page-content">
        <Helmet title={`Event | ${siteData.title}`}>

          <link rel="canonical" href={`${siteData.siteUrl}/event`} />
          <meta name="description" content={`${siteDescription}`} />
          <meta name="title" content={`Event | ${siteData.title}`} />

          <meta property="og:title" content={`Event | ${siteData.title}`} />
          <meta property="og:site_name" content="YOUCAT Indonesia" />
          <meta property="og:url" content={`${siteData.siteUrl}/event`} />
          <meta property="og:description" content={`${siteDescription}`}  />
          <meta property="og:image" content="https://static.youcat.id/ogimg/ogimg-youcat.png" />
          <meta property="og:locale" content="id_ID" />
          <meta property="og:type" content="website" />

        </Helmet>
        <div className="wrapper">
          <h1 className="page-title">Event-event</h1>
          <div className="page-body">
            <p className={pageStyles.quote}><span className={pageStyles.quoteSign}>“</span>Jika kamu ingin melakukan sesuatu untuk orang muda, lakukanlah bersama orang muda!<span className={pageStyles.quoteSign}>”</span></p>

            <p>Nasihat dari Kardinal Christoph Schonborn, Uskup Agung Wina yang juga salah satu inspirator dan pendukung YOUCAT sejak awal mula, selalu menjadi pegangan YOUCAT Indonesia untuk tak pernah lelah hadir dan menyapa setiap orang muda, termasuk untuk menunjukkan kepadamu kalau memang #Beriman itu #BukanRecehan.</p>
            <p>&nbsp;</p>
            <p>Yuk ikutan bergabung dengan event-event kami ini:</p>
          </div>
          <ul className="event-list grid-x grid-padding-x grid-padding-y small-up-1 medium-up-2 large-up-3">
            {posts.map(({ node }) => {
              return (
                <li key={node.slug} className="cell event-list-item">
                  <EventPreview event={node} />
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }
}

export default EventIndex

export const pageQuery = graphql`
  query EventIndexQuery {
    site {
      siteMetadata {
        title
        siteUrl
        siteImg
      }
    }
    allContentfulEvent(sort: { fields: [date], order: DESC }) {
      edges {
        node {
          title
          slug
          date(formatString: "DD MMMM YYYY")
          thumbnail {
            sizes(maxWidth: 640, maxHeight: 480, resizingBehavior: THUMB) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          excerpt
          venue
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/event.js